import React, { useState, useEffect } from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import AllJobsCarousel from './AllJobsCarousel';
import { CircularProgress, Typography, Grid, TextField, MenuItem, Button } from '@material-ui/core';
import { Job } from "./App"

const useStyles = makeStyles((theme: Theme) => 
    createStyles({
        search: {
            backgroundColor: "#546e7a",
            padding: 8,
            margin: 0,
            maxWidth: 1000
        },
        searchField: {
            backgroundColor: "#ffffff",
            width: 220
        },
        searchSubmit: {
            backgroundColor: "#95c54b",
            width: 220,
            height: 55,
            color: "#ffffff",
            '&:hover': {
                backgroundColor: "#649417",
                color: '#FFF'
            }
        }
    })
);

interface Props {
    jobs?: Array<Job>
    loading: boolean
}

export default function AllJobsWidget({ jobs, loading }: Props) {

    const classes = useStyles()

    const [filteredJobs, setFilteredJobs] = useState<Array<Job>>([])

    const [keywordInput, setKeywordInput] = useState<string>('')
    const [classification, setClassification] = useState<string>('')
    const [location, setLocation] = useState<string>('')

    useEffect(() => {
        if(jobs) {
            setTimeout(()=>{ window.parent.postMessage(document.body.scrollHeight, '*') }, 1000);
            setFilteredJobs(jobs)
        }
    }, [jobs])

    const handleSearchSubmit = () => {
        let newJobs: Array<Job>= []
        if(keywordInput !== "") {
            let keywordFilter = jobs?.filter((j: Job) => {
                return j.Position.toLowerCase().includes(keywordInput.toLowerCase()) || 
                        j.AdDetail.toLowerCase().includes(keywordInput.toLowerCase()) || 
                        j.Title.toLowerCase().includes(keywordInput.toLowerCase()) ||
                        j.ShortDescription.toLowerCase().includes(keywordInput.toLowerCase())
            })
            if(keywordFilter){
                newJobs.push(...keywordFilter)
            } 

            if(classification !== "") {
                let classificationFilter = newJobs.filter((j: Job) =>  j.Classification.includes(classification))
                newJobs = classificationFilter
            }

            if(location !== "") {
                let locationFilter = newJobs.filter((j: Job) =>  j.Location.includes(location))
                newJobs = locationFilter
            }
        } else if(classification !== "") {
            let classificationFilter = jobs?.filter((j: Job) =>  j.Classification.includes(classification))
            if(classificationFilter) {
                newJobs.push(...classificationFilter)
            }

            if(location !== "") {
                let locationFilter = newJobs.filter((j: Job) =>  j.Location.includes(location))
                newJobs = locationFilter
            }
        } else if(location !== "") {
            let locationFilter = jobs?.filter((j: Job) =>  j.Location.includes(location))
            if(locationFilter) {
                newJobs.push(...locationFilter)
            }
        } else {
            if(jobs) {
                newJobs.push(...jobs)
            }
        }
        setFilteredJobs(newJobs)
    }

    return (
        <div>
            <div style={{display: "flex", justifyContent: "center"}}>
                <Grid container spacing={2} className={classes.search} justify="center">
                    <Grid item>
                        <TextField
                            value={keywordInput}
                            variant="outlined"
                            placeholder="Enter Keywords"
                            InputProps={{ className: classes.searchField }}
                            onChange={(event: React.ChangeEvent<{ value: unknown }>) =>  setKeywordInput(event.target.value as string)} />
                    </Grid>
                    <Grid item>
                        <TextField
                            select
                            label={classification === "" ? "Job Classification" : ""}
                            value={classification}
                            variant="outlined"
                            InputProps={{ className: classes.searchField }}
                            InputLabelProps={{shrink: false}}
                            onChange={(event: React.ChangeEvent<{ value: unknown }>) => setClassification(event.target.value as string)}>
                            
                            <MenuItem value={''}><em>None</em></MenuItem>
                            <MenuItem value={'Trades'}>Trades</MenuItem>
                            <MenuItem value={'Logistics, Trans, Supply'}>Logistics, Trans, Supply</MenuItem>
                            <MenuItem value={'Hosp, Travel & Tourism'}>Hosp, Travel & Tourism</MenuItem>
                            <MenuItem value={'Other'}>Other</MenuItem>
                            <MenuItem value={'Manufacturing'}>Manufacturing</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item>
                        <TextField
                            select
                            label={location === "" ? "Location" : ""}
                            value={location}
                            variant="outlined"
                            InputProps={{ className: classes.searchField }}
                            InputLabelProps={{shrink: false}}
                            onChange={(event: React.ChangeEvent<{ value: unknown }>) => setLocation(event.target.value as string)}>
                            
                            <MenuItem value={''}><em>None</em></MenuItem>
                            <MenuItem value={'Auckland'}>Auckland</MenuItem>
                            <MenuItem value={'Wellington'}>Wellington</MenuItem>
                            <MenuItem value={'Silverdale'}>Silverdale</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item>
                        <Button className={classes.searchSubmit} variant="contained"
                            onClick={() => handleSearchSubmit()}>
                            <h3>Search</h3>
                        </Button>
                    </Grid>
                </Grid>
            </div>
            <div style={{display: "flex", justifyContent: "center", marginTop: 16}}>
                <Typography variant="h5" style={{color: "#259a49"}}>
                    Available Jobs
                </Typography>
            </div>
            <div style={{display: "flex", justifyContent: "center", paddingBottom: 32}}>
                {loading ?
                    <CircularProgress style={{marginTop: 32}} size={80} color="primary" />
                :
                    <AllJobsCarousel filteredJobs={filteredJobs} jobs={jobs} />
                }
               
            </div>
        </div>
    )
}